import { NotificationEventItem } from '../NotificationEventItem'
import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'

/**
 * generates a common NotificationEventItem for number/name edited notification
 * events
 *
 * the key for this NotificationEventItem should be `NumberOrNameEdited`
 *
 * ---
 *
 * the name is: Number or Name Edited
 *
 * the description is: The Package Name or Package Number is edited at any time, triggering a change to the SharePoint folder reference
 *
 * @param options {@link NumberNameEditedOptions}
 * @see {@link NotificationEventItem}
 */
export function NumberNameEditedNotificationEventItem<
  ID extends Lowercase<string>
>({ id }: NumberNameEditedOptions<ID>) {
  return new NotificationEventItem({
    id,
    name: 'Number or Name Edited',
    description:
      'The Package Name or Package Number is edited at any time, triggering a change to the SharePoint folder reference',
  })
}

type NumberNameEditedOptions<T extends Lowercase<string>> = Pick<
  ComplexEnumItem<T>,
  'id'
>
